const AngleLeft = ({ width = '14', height = '14' }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 14 14'
      fill='none'
    >
      <path
        d='M8.74995 11.5206C8.63795 11.5206 8.52594 11.4781 8.44077 11.3923L4.35744 7.30897C4.18652 7.13806 4.18652 6.86095 4.35744 6.69004L8.44077 2.6067C8.61169 2.43579 8.88879 2.43579 9.05971 2.6067C9.23062 2.77762 9.23062 3.05472 9.05971 3.22564L5.28556 6.99979L9.05971 10.7739C9.23062 10.9449 9.23062 11.222 9.05971 11.3929C8.97396 11.478 8.86195 11.5206 8.74995 11.5206Z'
        fill='#25314C'
      />
    </svg>
  );
};

export default AngleLeft;
